export const formatMoney = (money, locale = 'pt-BR', currency = 'BRL') => {
    return new Intl.NumberFormat(locale, { style: 'currency', currency }).format(money ?? 0)
}
